<template>
  <v-card class="v-card--wizard" elevation="12">
    <v-card-title class="headline">{{ title }}</v-card-title>
    <v-card-text>
      <v-tabs ref="tabs" v-model="internalValue" fixed-tabs icons-and-text>
        <v-tabs-slider class="mt-2" />

        <v-tab
          v-for="(item, i) in items"
          :key="i"
          :ripple="false"
          :disabled="!availableSteps.includes(i)"
          >{{ item.text
          }}<v-icon v-if="item.icon">{{ item.icon }}</v-icon></v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="internalValue" class="mt-4">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <v-card-actions class="px-6 py-4">
      <v-btn min-width="100" @click="$emit('cancel')">{{ $t("Cancel") }}</v-btn>
      <v-spacer />
      <v-btn
        :disabled="internalValue === 0"
        class="white--text"
        color="grey darken-2"
        min-width="125"
        @click="$emit('prev')"
        >{{ $t("Previous") }}</v-btn
      >
      <v-btn
        :disabled="!availableSteps.includes(internalValue + 1)"
        color="primary"
        min-width="100"
        :loading="progress"
        @click="$emit('next')"
        >{{
          internalValue === items.length - 1 ? $t("Save") : $t("Next")
        }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
// Mixins
import Proxyable from 'vuetify/lib/mixins/proxyable';

export default {
    name: 'BaseMaterialWizard',

    mixins: [Proxyable],

    props: {
        availableSteps: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '',
        },
        progress: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
